import React from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import CashOutUserModalBody from './CashOutUserModalBody';

export default (props) => {

    const {inputProps, orderList, onConfirm, onCancel, is_email_confirmed} = props;
    const {type, show, isFetching} = inputProps;

    return (<SweetAlert
                type={type}
                show={show}
                showCancel
                customClass="sweet-alert-big"
                confirmBtnCssClass={"alert-btn-confirm" + (isFetching ? " disabled" : "")}
                cancelBtnCssClass="alert-btn-cancel"
                showConfirm={(type === 'success' || type === 'error') ? false : true}
                confirmBtnText="Продолжить"
                cancelBtnText={type === 'success' ? "Готово" : "Отменить"}
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title={type === 'success' ? 'Успешно' : 'Вывести средства'}
                onConfirm={() => {
                    if(!is_email_confirmed) {
                        onCancel();
                        setTimeout(() => {
                            window.location.href = "/account";
                        }, 50);
                        return false;
                    }

                    (type === 'success') ? onCancel() : onConfirm()
                }}
                onCancel={() => onCancel()}
            >
                <CashOutUserModalBody {...props} orderList={orderList}/>
            </SweetAlert>)
}


// WEBPACK FOOTER //
// ./src/components/Profile/Balance/CashOutUserModal.js